import React from "react";

import { pillStyle, type PillTone } from "../logic";

/** Status pill — mirrors the handoff's pill() helper. */
export default function Pill({
  tone,
  children,
  style,
}: {
  tone: PillTone;
  children: React.ReactNode;
  style?: React.CSSProperties;
}) {
  return <span style={{ ...pillStyle(tone), ...style }}>{children}</span>;
}
